module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.actualBundleLoadedFlag) ? _c('div', [_c('div', {
    staticClass: "content content-boxed"
  }, [(_vm.dashboardFlags.evsensAdminFlag === false) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "bg-image img-rounded overflow-hidden push tesla-bg"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.labelTopPage1[_vm.actualLanguage]))]), _vm._v(" "), (_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('power-live-monitor') : _c('div', {
    staticClass: "block block-rounded push"
  }, [_c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: " form-group row"
  }, [_c('div', {
    staticClass: "col-xs-12 align-center"
  }, [_c('h1', {
    staticClass: "h4 font-w300 push"
  }, [_vm._v(_vm._s(_vm.realTimeMeasurementPanelNotAvailable[_vm.actualLanguage]))])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "h2 font-w300 push"
  }, [_vm._v(_vm._s(_vm.labelTopPage[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "block block-rounded"
  }, [_c('div', {
    staticClass: "block-header"
  }, [_c('h2', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelTopDatePicker[_vm.actualLanguage]))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('range-picker', {
    on: {
      "refresh": _vm.refreshData
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('display-channel-list')], 1)])])]) : _c('div', [_c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push-50"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 push-50"
  }, [_c('spinner', {
    attrs: {
      "size": "large"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b27242e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/measurements/Index.vue
// module id = 1576
// module chunks = 4